<template>
  <div class="pt-[128px] pb-[48px] h-[558px] brand-main">
    <div class="mx-auto flex gap-x-[32px] w-[1180px]">
      <div class="relative w-[680px] h-[382px]">
        <VideoPlayer class="brand-video" :url="videoSrc" @play="onPlay" />
      </div>
      <div class="flex-1">
        <div class="w-[230px] h-[64px]">
          <BrandLogo :media="currBrand" :h="64" png />
        </div>
        <div class="mt-[16px] mb-[20px] text-[32px] font-medium leading-[44px]">
          {{ currBrand.title }}
        </div>
        <div
          class="text-[16px] text-[#000] font-normal leading-[28px] opacity-[70]"
        >
          {{ currBrand.description }}
        </div>
      </div>
    </div>
  </div>
  <div class="pt-[48px]">
    <div class="mx-auto flex gap-x-[40px] w-[1180px]">
      <!-- 左侧悬浮 -->
      <div
        class="sticky top-[100px] p-[24px] w-[276px] h-fit rounded-[24px] bg-white brand-content__card"
      >
        <div class="h-[60px]">
          <BrandLogo :media="currBrand" :h="60" />
        </div>
        <div
          class="mb-[9px] pt-[16px] pb-[11px] text-[14px] leading-[28px] opacity-[80] brand-content__card--quote"
        >
          <div v-for="(str, index) in currBrand.feedback" :key="index">
            {{ str }}
          </div>
        </div>
        <div class="h-1 bg-[#ECEFF2]"></div>
        <NuxtLink
          to="/platform"
          target="_blank"
          class="block mt-24 text-primary text-[16px] leading-[22px] no-underline hover:text-highlight"
          @click="freeToUse"
        >
          免费试用有言&gt;
        </NuxtLink>
      </div>
      <!-- 右侧内容 -->
      <div class="brand-content">
        <BrandContent :content="content" />
      </div>
    </div>
  </div>
  <div
    class="mt-[120px] mb-[20px] text-center text-[32px] leading-[44px] font-medium"
  >
    更多客户案例
  </div>
  <!-- 合作品牌 -->
  <BrandMarquee :cur-item="source.home8BrandSide.value" class="mb-[100px]" />
</template>

<script setup lang="ts">
import useAppInitData from './init'
import BrandContent from '@/features/landing/brand-content.vue'
import { AttrKey } from '@/constants/landing'
import { TRACK_EVENT } from '@/utils/track'
import VideoPlayer from '@/components/videoPlayer/index.vue'
import BrandLogo from '@/features/landing/brand-marquee/brand-logo.vue'
import BrandMarquee from '@/features/landing/brand-marquee/index.vue'

const route = useRoute()

const { source } = useAppInitData()

const currBrand = computed(() => {
  const target = source.home8BrandSide.value?.resource[0].mediaArray.find(
    ($) => $.id === +route.params.id
  )

  return target
})

const videoSrc = computed(() =>
  getCurMediaItemAttribute(currBrand.value?.mediaItem.data, AttrKey.URL, 1)
)

const content = computed(() => currBrand.value?.content)

function onPlay() {
  trackEvent(TRACK_EVENT.CLICK_BRAND_PLAY_VIDEO)
}

function freeToUse() {
  trackEvent(TRACK_EVENT.CLICK_BRAND_FREE_TO_USE)
}

onMounted(() => {
  trackEvent(TRACK_EVENT.PAGE_BRAND_DETAIL, {
    title: currBrand.value?.title,
  })
})
</script>

<style lang="scss">
.brand {
  &-main {
    background: linear-gradient(
      135deg,
      rgba(105, 98, 255, 0.3) 0%,
      rgba(0, 160, 233, 0.18) 100%
    );

    .vjs-tech {
      width: 100%;
      height: 100%;
    }
  }
  &-content {
    padding: 0 4px;
    flex: 1;
    &__card {
      box-shadow: 0px 0px 40px 5px rgba(181, 181, 182, 0.2);
      &--quote {
        position: relative;
        &::before {
          position: absolute;
          top: 0;
          left: 0;
          content: ' ';
          width: 47px;
          height: 40px;
          background: url(~/assets/images/quote.webp) no-repeat center/contain;
        }
        &::after {
          position: absolute;
          right: 0;
          bottom: 0;
          content: ' ';
          width: 56px;
          height: 47px;
          background: url(~/assets/images/quote.webp) no-repeat center/contain;
          transform: rotate(180deg);
        }
      }
    }
    img,
    video {
      width: 100%;
    }
  }
}

.brand-video {
  video {
    background-color: #000 !important;
  }
}
</style>
